/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespCollectionsModules_shippingFilters = ReadonlyArray<{
    readonly " $fragmentRefs": FragmentRefs<"SbRespCollectionsComponents_shippingFilters">;
    readonly " $refType": "SbRespCollectionsModules_shippingFilters";
}>;
export type SbRespCollectionsModules_shippingFilters$data = SbRespCollectionsModules_shippingFilters;
export type SbRespCollectionsModules_shippingFilters$key = ReadonlyArray<{
    readonly " $data"?: SbRespCollectionsModules_shippingFilters$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespCollectionsModules_shippingFilters">;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespCollectionsModules_shippingFilters",
  "type": "ShippingFilterType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespCollectionsComponents_shippingFilters",
      "args": null
    }
  ]
};
(node as any).hash = '7eec9dee98bd0402f377d170e195f69a';
export default node;
